<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Plany urlopowe moich pracowników</span>
        <h3 class="page-title">
          <template>Plan urlopowy:
            <p class="mt-2" style="font-weight: 100">{{data.user_name}}</p>
          </template>
        </h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/plany-urlopowe-pracownikow')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          Wróć do listy
        </d-button>
      </d-col>
    </d-row>
    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <d-tabs card>
          <!-- Dane ogólne -->
          <d-tab :title="'Plan urlopowy'" active>
            <h4 class="mb-3 pb-3 border-bottom">
              Dane ogólne:
            </h4>
            <validation-observer ref="holidays-plans-form" tag="form">
              <div class="form-group">
                <div class="form-control">
                  <div class="form-group mt-4">
                    <label style="font-weight: 600">
                      Imię i nazwisko:
                    </label>
                    <p class="simpleText">
                      {{data.user_name}}
                    </p>
                  </div>
                  <div class="form-group">
                    <label style="font-weight: 600">
                      Urlop od:
                    </label>
                    <p class="simpleText">
                      {{data.date_start}}
                    </p>
                  </div>
                  <div class="form-group">
                    <label style="font-weight: 600">
                      Urlop do:
                    </label>
                    <p class="simpleText">
                      {{data.date_end}}
                    </p>
                  </div>
                </div>
              </div>
            </validation-observer>
            <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center">
              Trwa ładowanie danych&hellip;
            </div>

            <d-alert
              v-if="loadError"
              show
              theme="warning">
              Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
            </d-alert>
          </d-tab>
        </d-tabs>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

const moment = require('moment');

export default {
  name: 'holidays-form',
  components: { DatePicker },
  computed: {
    accountPermissions () {
      return this.$store.getters.getAccount
    },
    allDataLoaded () {
      return this.loaded && this.loadedHolidays;
    },
    isEdit () {
      return !!this.$route.params.id;
    }
  },
  data() {
    return {
      data: {
        date_start: '',
        date_end: '',
        user_name: ''
      },
      loaded: false,
      loadError: false,
      showAccepted: false,
      range: [],
      holidays: [],
      loadedHolidays: false,
      moment
    };
  },
  mounted () {
    this.loadItemData();
    this.loadAdditionalData();
  },
  created () {
    setTimeout(() => {
      this.calendarDate();
    }, 1000);
  },
  methods: {
    userAccountGet () {
      this.$store.dispatch('userAccountGet')
    },
    calendarDate () {
      this.range = [(this.data.date_start), (this.data.date_end)];
    },
    loadItemData () {
      FormUtils.loadItemData(this, {
        endpointBase: '/holidays-plans/item/',
        instanceFields: ['date_start', 'date_end', 'user_name'],
        loadedKey: 'loaded'
      });
    },
    loadAdditionalData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/holidays-plans/items',
        params: {
          pagination: false
        },
        outputKey: 'holidays',
        loadedKey: 'loadedHolidays',
        errorKey: 'loadError',
        successAction: () => {
          if (this.data.id) {
            this.holidays = this.holidays.filter(holiday => holiday.id === this.data.id);
          }
        }
      });
    }
  }
};
</script>
<style>
  @import "../../assets/scss/layout/holidays-children.scss";
</style>
